"use client";
import { JSX, useEffect, useRef, useState } from "react";
import { ModalProps } from "./ModalProps";
import { XMarkIcon } from "assets";

export default function SmallScreenModel({
  showModal,
  setShowModal,
  children,
  className,
}: ModalProps): JSX.Element {
  const [isModalVisible, setIsModalVisible] = useState(false);
    useEffect(() => {
        if (showModal) {
          setTimeout(() => setIsModalVisible(true), 10);
        } else {
          setIsModalVisible(false);
        }
      }, [showModal]);
     const backdropTransition = showModal
      ? "opacity-100"
      : "opacity-0";
    const modalTransition = isModalVisible
      ? "scale-100 opacity-100"
      : "scale-95 opacity-0";
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target as Node)
      ) {
        setShowModal(false);
      }
    };

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        setShowModal(false);
      }
    };

    if (showModal) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("keydown", handleKeyDown);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [showModal, setShowModal]);
  if (!showModal && !isModalVisible) {
    return <></>;
  }
  return (
    <>
      {showModal && (
        <div
          className={`fixed inset-0 z-[70] flex items-center justify-center bg-black bg-opacity-50 ${backdropTransition} ${className}`}
          onClick={(e) => e.stopPropagation()}
        >
          <div
            className={`bg-white  w-11/12 sm:w-4/5 md:w-3/5 lg:w-2/4 xl:w-1/3 p-6 rounded-lg shadow-lg relative border-[1px] border-primary-500 transition-all duration-300 ease-in-out  ${modalTransition}`}>
            <button
              onClick={() => setShowModal(false)}
              className="absolute border-2 border-primary-500 p-1 top-3 right-3 text-primary-900 hover:text-red-800 rounded-full hover:bg-red-200"
            >
              <XMarkIcon className=" size-4 text-black hover:text-red-700 transition-all duration-300 ease-in-out" />
            </button>
            <div className="w-full mt-2 text-gray-600 max-h-[80vh] overflow-y-auto hide-scrollbar">{children}</div>
          </div>
        </div>
      )}
    </>
  );
}
